import { useRFS } from "@/api/rfs";
import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { LogHistoryPanel } from "@/features/rfs/LogHistoryPanel";
import { useParams } from "react-router-dom";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { H2 } from "@/components/ui/typography";
import { LucideArrowLeft } from "lucide-react";
import { Anchor } from "@/components/ui/anchor";

export default function LogHistory() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: rfs } = useRFS({ id });

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "RFS Submission",
          },
          {
            href: "/rfs/rfs",
            label: "RFS List",
          },
          {
            href: `/rfs/rfs/${id}`,
            label: "Detail",
          },
          {
            label: `Log History`,
          },
        ]}
      />
      <div className="flex w-full items-center justify-between">
        <H2>Log History - {rfs?.clusterId}</H2>
        <Anchor href={`/rfs/rfs/${rfs?.id}`} mood="axiata-blue-outline">
          <LucideArrowLeft size={16} />
          <span className="ml-2">Back</span>
        </Anchor>
      </div>
      <LogHistoryPanel />
    </>
  );
}
